export const ADOBE_TARGET = 'AdobeTarget';
export const QUICK_LINKS = 'quickLinks';
export const SWEEPSTAKES_BANNER = 'sweepstakesBanner';
export const TOP_OF_PAGE_BANNER = 'topOfPageBanner';

/**
 * Components
 */
export const BENTO_HERO = 'bentoHero';
export const COMPONENT_SELECTOR = 'ComponentSelector';
export const INTERNAL_MARKETING_BANNER = 'internalMarketingBanner';
